import React from 'react'
import {
  Breadcrumbs,
  Construction,
  Hero,
  Page,
  ServiceContact,
} from '@components'

const meta = {
  title: 'Izvođenje radova protupožarne zaštite',
  description: 'U svrhu ispunjavanja visoko postavljenih zahtjeva surađujemo s najboljim monterskim tvrtkama u Republici Hrvatskoj.',
}

const Homepage = () => (
  <Page
    isHomepage
    meta={meta}
  >
    <Breadcrumbs
      links={[
        { link: '/', name: 'Početna'},
        { link: '/usluge', name: 'Usluge'},
        { link: '/usluge/izvodjenje-radova-protupozarne-zastite', name: 'Izvođenje radova protupožarne zaštite'},
      ]}
    />
    <Hero
      title="Usluga"
      subtitle={meta.title}
      description={meta.description}
    />
    <Construction />
    <ServiceContact id="izvođenje" />
  </Page>
)

export default Homepage